import { render, staticRenderFns } from "./DirectoryNewBusiness.vue?vue&type=template&id=b1661f62&scoped=true&"
import script from "./DirectoryNewBusiness.vue?vue&type=script&lang=js&"
export * from "./DirectoryNewBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryNewBusiness.vue?vue&type=style&index=0&id=b1661f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1661f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1661f62')) {
      api.createRecord('b1661f62', component.options)
    } else {
      api.reload('b1661f62', component.options)
    }
    module.hot.accept("./DirectoryNewBusiness.vue?vue&type=template&id=b1661f62&scoped=true&", function () {
      api.rerender('b1661f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/DirectoryNewBusiness.vue"
export default component.exports